import wrapper from 'wrapper';
import events from '../../utils/events-emitter';

class FilterButtons {
    constructor() {
        this.anchorLinks = wrapper.selectAll('.anchor-link');
        this.legendDiv = wrapper.select('.filter-buttons__legend');
        this.replaceLegend();
        this.setup();
        this.buttons = wrapper.selectAll('.filter-buttons__button-input');
        this.addClickListeners();
    }

    replaceLegend() {
        this.legendDiv.innerHTML = __('filter_button_instructions');
    }

    addClickListeners() {
        this.buttons.forEach((button) => button.addEventListener('change', (e) => {
            e.preventDefault();
            this.handleButtonClick(button);
        }));
    }

    setup() {
        // Replaces anchor links with button filters
        this.anchorLinks.forEach((link, i) => {
            // Un-hides the "All" filter
            if (link.classList.contains('hidden')) {
                link.classList.remove('hidden');
            }
            const categoryName = link.querySelector('p').innerHTML;
            const targetValue = link.classList[1];
            const buttonEl = document.createElement('li');
            buttonEl.classList.add(
                'filter-buttons__button-container',
                `filter-buttons__button-container--${targetValue}`,
            );
            buttonEl.innerHTML = `<input
                type='radio'
                id='radio--${targetValue}'
                value=${targetValue}
                name="category-filter"
                aria-labelledby='radio--${targetValue}--label'
                class='filter-buttons__button-input filter-buttons__button-input--${targetValue} ${i === 0 ? 'active' : ''}'
                tabindex="0" />
                    <label
                        id='radio--${targetValue}--label'
                        for='radio--${targetValue}'
                        class='filter-buttons__button-label ${link.classList[1]}'
                        data-attribute=${targetValue}
                        focusable="false"
                        aria-hidden="true"
                    >
                        ${categoryName}
                    </label>`;
            link.parentNode.replaceChild(buttonEl, link);
        });
        // Sets 'all' button as checked
        wrapper.select('.filter-buttons__button-input.active').setAttribute('aria-checked', true);
        wrapper.select('.filter-buttons__button-input.active').setAttribute('checked', true);
        // Adds class to button container for styling
        wrapper.select('.filter-buttons__container').classList.add('enhanced');
    }

    handleButtonClick(button) {
        const btnTarget = button;

        this.buttons.forEach((btn) => {
            if (btn.classList.contains('active')) {
                btn.classList.remove('active');
                btn.setAttribute('aria-selected', false);
            }
        });

        btnTarget.classList.add('active');
        btnTarget.setAttribute('aria-selected', true);
        const activeFilter = btnTarget.classList[1].replace(
            'filter-buttons__button-input--',
            '',
        );
        events.emit('filter-update', activeFilter);
        wrapper.trackUserAction(
            'button clicked',
            `filter: ${activeFilter}`,
        );
    }
}

export default FilterButtons;
